import React from 'react'
import { Table, TableContent } from 'reatable' 

export const APIsTable = ({ nameLabel = 'Property', typeLabel = 'Type', ...props}) => (
	<Table
		{...props}
		columns={columns.map((row) => { 
			const n = { ...row }
			if(n.dataIndex === 'name') {
				n.label = nameLabel
			} else if(n.dataIndex === 'type') {
				n.label = typeLabel
			}
			return n
		})}
		collapsible={{
			render: (row) => (
				<div className='px-3 py-2'>
					<APIsTable 
						nameLabel={row.type.includes('function') ? 'Argument' : undefined} 
						{...props} data={row.data} isNested />
				</div>
			),
			collapseWhen: (row) => 'data' in row,
			accordion: true,
		}}
	>	
		<div className={!props.isNested ? 'n-flat of-y-auto br-1r' : 'n-bordered'}>
			<TableContent className='table-api n-table-bordered n-text-color' />
		</div>
	</Table>
);

const columns = [
	{
		dataIndex: 'name',
		label: 'Property',
		cellAttr: (row, index, actions) => ({
			colSpan: row.type === '' && row.description === '' ? 4 : undefined,
		}),
	},
	{
		dataIndex: 'type',
		label: 'Type',
		render: (type, row, i, { collapsible }) => (
			<span className='d-flex flex-center-y'>
				<span className='mr-2'>{type}</span>
				{collapsible && (
					<button
						className={`ml-auto n-btn btn-caret${
							collapsible.collapsed ? ' active' : ''
						}`}
						onClick={collapsible.collapseHandler}
					/>
				)}
			</span>
		),
		mountCellWhen: (row) => row.type !== '',
	},
	{
		dataIndex: 'default',
		label: 'Default',
		mountCellWhen: (row) => row.default !== '',
	},
	{
		dataIndex: 'description',
		label: 'Description',
		mountCellWhen: (row) => row.description !== '',
	},
];
